import React from 'react'
import ReactDOM from 'react-dom'
import { PageBase } from 'frontend/common-imports'
import EventBookingForm from 'frontend/pages/events/event-booking-form'
import Glide, { Controls, Autoplay, Images, Swipe, Breakpoints, Lazy, GLIDE_SETTINGS } from 'frontend/lib/glide/bundle'

export default class EventsPage extends PageBase {
  static companiesSlider () {
    console.debug('EventsPage.companiesSlider()')

    new Glide('.companies .slider',
      Object.assign(
        GLIDE_SETTINGS,
        {
          type: 'carousel',
          autoplay: 2000,
          perView: 8,
          focusAt: 'center',
          breakpoints: {
            480: { perView: 1 },
            768: { perView: 3 },
            1024: { perView: 6 }
          }
        }
      )
    ).mount({ Swipe, Images, Autoplay, Breakpoints, Lazy })
  }

  static cateringSlider () {
    console.debug('EventsPage.cateringSlider()')

    new Glide('.catering .slider',
      Object.assign(
        GLIDE_SETTINGS,
        {
          type: 'slider',
          perView: 1
        }
      )
    ).mount({ Controls, Swipe, Images, Breakpoints })
  }

  static celebritiesSlider () {
    console.debug('EventsPage.celebritiesSlider()')

    new Glide('.celebrities .slider',
      Object.assign(
        GLIDE_SETTINGS,
        {
          type: 'carousel',
          perView: 5,
          focusAt: 'center',
          breakpoints: {
            768: { perView: 1 },
            1280: { perView: 3 }
          }
        }
      )
    ).mount({ Controls, Swipe, Images, Breakpoints, Lazy })
  }

  static reservationForm () {
    ReactDOM.render(
      React.createElement(EventBookingForm, { pageController: this, submitDisabled: !!this.recaptchaPlace }),
      document.getElementById('event_booking_form_mount_point')
    )
  }

  static reCaptchaSuccess() {
    this.formComponent.onReCaptchaSuccess({'gRecaptchaResponse': this.recaptchaResponseField?.value})
  }

  static handleStylesApplied () {
    this.onEnter('.companies .slider', () => this.companiesSlider())
    this.onEnter('.catering .slider', () => this.cateringSlider())
    this.onEnter('section.reservation', () => this.reservationForm())
    this.onEnter('.celebrities .slider', () => this.celebritiesSlider())
  }

  static get recaptchaResponseField () {
    return document.querySelector('#g-recaptcha-response')
  }

  static get recaptchaPlace () {
    return document.querySelector('.reservation .recaptcha_place')
  }
}

EventsPage.init()
